import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonThemeProvider } from './ThemeProvider.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonThemeProvider({ prefix }));
}
